import Plyr from 'plyr';
import { getDatasetSafe, watchVisible } from '@nx-paeonia/utils-dom';

const videoPlayers = document.querySelectorAll<HTMLElement>('.js-video-player');

videoPlayers.forEach((el) => {
    const autopause = getDatasetSafe(el, 'autopause', false);
    const watch = getDatasetSafe(el, 'watch', false);

    const player = new Plyr(el, {
        autopause
    });

    if (watch) {
        watchVisible(
            el,
            {
                onVisible: () => player.play(),
                onHidden: () => player.pause(),
            }

        )
    }
});
